// extracted by mini-css-extract-plugin
export default {"oculus_checkbox":"oculus_checkbox___c7IhO","size_s":"size_s___EzO2z","size_m":"size_m___OHzAW"};